import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { CourseSideMenuComponent } from './course-side-menu/course-side-menu.component';

@Component({
  selector: 'app-course-details',
  imports: [TranslateModule, RouterOutlet, CourseSideMenuComponent],
  templateUrl: './course-details.component.html',
  styleUrl: './course-details.component.scss',
})
export class CourseDetailsComponent {
  constructor() {}
}
